var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIHat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 28.9999V22.3298L16.0169 26.9324C18.4835 28.3485 21.5165 28.3485 23.9831 26.9324L32 22.3298V28.9999C32 29.2651 31.8946 29.5194 31.7071 29.707L31.7039 29.7101L31.6993 29.7147L31.6855 29.7282L31.6402 29.7717C31.602 29.8077 31.5482 29.8575 31.4788 29.9192C31.3401 30.0425 31.1391 30.2133 30.8778 30.4156C30.3555 30.82 29.5896 31.3521 28.5956 31.8822C26.6065 32.9431 23.6958 33.9999 20 33.9999C16.3042 33.9999 13.3935 32.9431 11.4044 31.8822C10.4104 31.3521 9.64452 30.82 9.1222 30.4156C8.86086 30.2133 8.65989 30.0425 8.52118 29.9192C8.45181 29.8575 8.39795 29.8077 8.35984 29.7717L8.31449 29.7282C8.11876 29.5366 8 29.2755 8 28.9999ZM37.4979 16.8673L22.9874 25.1979C21.1374 26.26 18.8626 26.26 17.0126 25.1979L4 17.7272L4 26.9999C4 27.5522 3.55228 27.9999 3 27.9999C2.44772 27.9999 2 27.5522 2 26.9999V16C2 15.62 2.21197 15.2894 2.52412 15.1202L17.0126 6.80196C17.7063 6.40367 18.4598 6.15473 19.2283 6.05516C19.4717 6.02361 19.7167 6.00705 19.9617 6.00549C20.7479 6.00048 21.5348 6.1498 22.2754 6.45346C22.5183 6.55303 22.7562 6.6692 22.9874 6.80197L37.4979 15.1328C37.8085 15.3111 38 15.6419 38 16C38 16.3582 37.8085 16.689 37.4979 16.8673Z",
    fill: "url(#paint0_linear_1358_22519)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1358_22519",
    x1: 20,
    y1: 6.00537,
    x2: 20,
    y2: 33.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B212A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293744"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIHat);
export default __webpack_public_path__ + "static/media/i-hat.c65705a3.svg";
export { ForwardRef as ReactComponent };